const articleKirkElliott = {
  "key": "w07",
  "title": "Kirk Elliott PhD",
  "skills": "UX/UI | Front-End Dev",
  "date": "Feb 2023",
  "path": "kirk-elliott",
  "graphic": "kephd/KEPHD_Cover.jpg",
  "content": [
    {
      "component": "Title",
      "content": "Kirk Elliott PhD Storage Landing Site"
    },
    {
      "component": "Subheading",
      "design": "centered",
      "content": "UX/UI Design | Front-End Development"
    },
    {
      "component": "Image",
      "source": "kephd/KEPHD_StorageSite_Preview.jpg",
      "alt": "KEPHD Storage Website"
    },
    
    {
      "component": "Body",
      "design": "full-width centered caption",
      "content": "Kirk Elliott PhD helps clients diversify their financial portfolio to maintain long-term stability and reach business goals. Their strategy employs the use of precious metals and precious metal IRAs."
    },
    {
      "component": "Heading",
      "content": "Introduction"
    },
    {
      "component": "Body",
      "content": "Before we entered the picture, KEPHD was advising clients and helping them obtain precious metals as a form of financial strategy. As their portfolio continued to grow, it became apparent they needed to offer a quality storage solution to their clients. Texas Precious Metals Depository entered in to offer this service on behalf of KEPHD."
    },
    {
      "component": "Body",
      "content": "I was placed in a unique position with Texas Precious Metals to deliver KEPHD with a set of informative landing pages to explain the depository solution and storage process."
    },
    {
      "component": "Subheading",
      "content": "My involvement included...",
      "design": "centered"
    },
    {
      "component": "List",
      "listType": "unordered",
      "content": [
        "Pitch a feasible design direction for the website",
        "Build a high-fidelity prototype for client & stakeholder approvals",
        "Define UI components",
        "Build out UI components (used React)",
        "Collaborate with other developers to facilitate buildout",
        "Establish design system (using SCSS)",
        "Optimize for mobile experiences",
        "Obtain approvals and team buy in on design and implementation strategy"
      ]
    },
    {
      "component": "Button",
      "content": "Visit Website",
      "target": "_blank",
      "destination": "https://storage.kirkelliottphd.com",
      "design": "button-1"
    },
    {
      "component": "Heading",
      "content": "Design Solution"
    },
    {
      "component": "Body",
      "content": "This project started on February 8th, 2023 and the pages were deployed February 21st of the same year (exactly 2 weeks). Delivering on such a quick turn required obtaining an intense laser focus on the goal and need, setting a crystal clear vision of the target very quickly, and cultivating the cooperation of a team of talented individuals who could make it&nbsp;happen."
    },
    {
      "component": "Subheading",
      "content": "Grasping the Vision"
    },
    {
      "component": "Body",
      "content": "To grasp the vision as early as possible, I dove into research moments after receiving the assignment. First, I sought to understand the project requirements. This included writing down goals and constructing a target site map."
    },
    {
      "component": "Image",
      "source": "kephd/KE_sitemap-proposal.jpg",
      "alt": "Site map for website build"
    },
    {
      "component": "Body",
      "design": "full-width centered caption",
      "content": "This slide is from the presentation I put together for our first design review meeting. I often use slides in meetings to explain design intent and record details agreed upon during the meeting. Here, we determined that we didn't need an “About Us” page, and later decided we didn't need all the secondary pages as well."
    },
    {
      "component": "Body",
      "content": "Through discussions with stakeholders, I was able to determine a viable direction on what pages and content would be needed. I would later validate this page structure with the vision of the rest of the team during a meeting where I would review the design and details surrounding the project scope. I have found this to be a highly effective method in establishing team unity; pitching well-thought-out ideas or directives in a collaborative team meeting where you welcome candid critique of the plan and make tweaks as needed."
    },
    {
      "component": "Body",
      "content": "Research in this instance also included gaining an understanding of the Kirk Elliott PhD brand, as it became apparent we hoped to match our mini-site with the design of the parent website, <a href=\"http://kirkelliottphd.com\" target=\"_blank\">kirkelliottphd.com</a>."
    },
    {
      "component": "Image",
      "source": "kephd/KEPHD-research.jpg",
      "alt": "Design Research for KEPHD"
    },
    {
      "component": "Body",
      "content": "With our limited time for research and development, I focused on capturing and incorporating only the visual characteristics from the parent website into our new build, while relying on existing TPM content for the written page information. Fonts, colors, UI components, layouts, and typographic hierarchies would be carried over from kirkelliottphd.com, so as to present a cohesive unified brand experience to visitors of both&nbsp;sites."
    },
    {
      "component": "Subheading",
      "content": "Casting a Target"
    },
    {
      "component": "Body",
      "content": "To compile this research into actionable designs, I used (you guessed it) Figma to create high-fidelity screen mockups for each page."
    },
    {
      "component": "Image",
      "source": "kephd/KE_figma-prototype.jpg",
      "alt": "Mockups created in Figma"
    },
    {
      "component": "Body",
      "design": "full-width centered caption",
      "content": "Using Figma allowed us to quickly lock in a few of the finer front-end dev details like margins, font sizes, colors, shadows, spacing, structure, and page routing. When we got to coding the site, there was very little guess work to do form the design perspective."
    },
    {
      "component": "Body",
      "content": "The mockups were turned into a shareable prototype, used in the initial design pitch and review, to show what our target build would be like. After a few tweaks, we also shared it with our internal team for copy editing and general feedback. Ultimately, it was shared with stakeholders at Kirk Elliott PhD, who were able to gain a very strong idea of the end product before a single line of code was written."
    },
    {
      "component": "Body",
      "content": "Going back a little in our story, I mentioned hosting an initial design review meeting. I scheduled this as soon as I had a fairly solid and complete understanding of the target design. By this point, I had conducted research, determined requirements, and fleshed out the Figma prototype. I had then compiled all of this content into a slide presentation for the team to review and discuss together."
    },
    {
      "component": "Image",
      "source": "kephd/KE_incomplete-list.jpg",
      "alt": "A chart presented in meeting with incomplete task for go-no-go."
    },
    {
      "component": "Body",
      "design": "full-width caption",
      "content": "This chart was presented during the meeting as a slide to reveal open action items that might need to be done and who I expected could/should own it. I left the “Make it So” column blank so we could make a decision during the meeting."
    },
    {
      "component": "Body",
      "content": "The meeting was the proving ground for the work to come. If the team could agree on a vision for the product and a feasible scope, we could proceed to the next step of actually creating it. Thankfully, the response from the team was very positive, and likewise our contacts at KEPHD loved the design and was happy to&nbsp;proceed."
    },
    {
      "component": "Subheading",
      "content": "Creating a Product"
    },
    {
      "component": "Body",
      "content": "As mentioned earlier, the timeline for delivery was extremely short for this brand new site. This fact alone set a fire under me and the other developer to take immediate action in executing on the project. Probably, within hours of getting a green light on initial design concepts, we had a Github repository set up for us to begin our work. We were able to do this because we were given full autonomy to make decisions and execute. In addition, I had periodically picked the brain of the developer to understand his plan for building out the design I was pitching. We had predetermined that it might be possible for me to assist with the buildout since he would likely try building with React.js, a popular front-end framework I was also familiar with using. Also, we could start quickly because I had designed our UI with components in mind."
    },
    {
      "component": "Body",
      "content": "I <strong><u>can not emphasize enough</u></strong> how important it was for the success of this project that we maintained an open and mutually beneficial line of communication. We would tackle coding challenges together, frequently debrief on what we are working on or had recently completed. We would talk about what we might be able to do next after a certain task is complete. We would celebrate successes together! We would consider what was still open and see what would be most valuable to do next; what would help the other person proceed. And we did all of this without a project management system in place. Nothing was assigned but by word of mouth, and everything was immediately tested. We would talk about possible solutions and then take action to make it happen. We would also try and merge code to our main branch every day at some&nbsp;point."
    },
    {
      "component": "Body",
      "content": "For slightly less than 2 weeks, this developer and I were able to accomplish the entire buildout of every page from the design, and have it live by the deadline. I believe cultivating the cooperative, mutually-beneficial environment was critical to helping us reach our goal, for several reasons: accountability, clarity, excitement, focused intensity. These were all present because cooperation and trust was present, along with mutual respect. A benefit of working so closely and intently with another individual is it allows you to understand, and RESPECT their strengths, and weaknesses, so as to play to those in accomplishing the goal. For example, we learned I was way better at CSS than him, so we felt comfortable letting him set infrastructure and having me come in later to style according to spec. I could rely on him to make sure the codebase went live on the servers and to assist with the buildout complex React components. We were ok with our differences and talked openly about them. We were&nbsp;equals."
    },
    {
      "component": "Heading",
      "content": "Conclusion"
    },
    {
      "component": "Image",
      "source": "kephd/KEPHD_Cover.jpg",
      "alt": "in conclusion cover art"
    },
    {
      "component": "Body",
      "content": "The buildout of the Kirk Elliott PhD Depository Solutions informational website was one success story I'm very proud to share with others. Here's why:"
    },
    {
      "component": "Body",
      "content": "It validates my capabilities and <u>expertise in branding</u>, learned during my years with Dexter&nbsp;Solutions and the hospitality&nbsp;industry."
    },
    {
      "component": "Body",
      "content": "It showcases my skills as a <u>UX/UI designer</u> and Figma's role in my design&nbsp;process."
    },
    {
      "component": "Body",
      "content": "It highlights the breadth of my skillset, spanning <u>project management</u> and&nbsp;<u>development</u>."
    },
    {
      "component": "Body",
      "content": "It proves a team management style centered on <u>cooperation</u>, <u>mutual respect</u>, and <u>laser focus</u> to be more effective for executing work than high tech systems and&nbsp;process."
    }
  ]
}

export default articleKirkElliott;